import React from 'react'

interface ReleaseVersionsProps {
  KnownIssues: string
  NewFeatures: string
  ResolvedIssues: string
}

const ReleaseVersions: React.FC<ReleaseVersionsProps> = ({
  KnownIssues,
  NewFeatures,
  ResolvedIssues,
}) => {
  return (
    <>
      {NewFeatures?.length > 0 && (
        <div
          aria-label='New Features'
          className='title-color20   poppins-semibold font-12'
          tabIndex={0}
        >
          New Features
        </div>
      )}
      <ul aria-live='polite' className='list-type-none my-2' tabIndex={0}>
        {NewFeatures?.length > 0 && (
          <span 
            dangerouslySetInnerHTML={{
              __html: NewFeatures,
            }}
          ></span>
        )}
      </ul>
      {ResolvedIssues?.length > 0 && (
        <div
          aria-label='Resolved issues'
          className='title-color20 poppins-semibold font-12'
          tabIndex={0}
        >
          Resolved issues
        </div>
      )}
      <ul aria-live='polite' className='list-type-none my-2' tabIndex={0}>
        {ResolvedIssues?.length > 0 && (
          <span 
            dangerouslySetInnerHTML={{
              __html: ResolvedIssues,
            }}
          ></span>
        )}
      </ul>
      {KnownIssues?.length > 0 && (
        <div
          aria-label='Known Issues'
          className='title-color20  poppins-semibold font-12'
          tabIndex={0}
        >
          Known Issues
        </div>
      )}
      <ul aria-live='polite' className='list-type-none my-2' tabIndex={0}>
        {KnownIssues?.length > 0 && (
          <span 
            dangerouslySetInnerHTML={{
              __html: KnownIssues,
            }}
          ></span>
        )}
      </ul>
    </>
  )
}

export default ReleaseVersions
